import React from 'react'
import Navber from '../components/navber'

function Mainlayout({children}) {
  return (
    <div>
        <Navber />
        <div>{children}</div>
    </div>
  )
}

export default Mainlayout